// extracted by mini-css-extract-plugin
export default {"container":"container--1bmJt","menu-item":"menu-item--1ey7V"};